import SkeletonBlock from '@sharedComponents/SkeletonBlock';

/**
 * Skeleton of an icon-only ghost `Button`: a square as tall as its 40px minimum height, with the same corners.
 */
const SkeletonIconButton = () => <SkeletonBlock width="40px" height="40px" borderRadius="var(--radius-m)" />;

export default SkeletonIconButton;
